/* global React */
// import { useEffect, useRef } from 'react'
import PlatformEvent from 'lib/util/event'

const { useEffect, useRef } = React

/**
 * Hook Use Event Handler
 *
 * attaches and detaches events
 *
 * for more infos: https://gist.github.com/gragland/ae701852ae6159c712d860a946cd7ca0
 *
 * current usage is fault, the element is always null, ie !ref.current
 *
 * @param eventName
 * @param handler
 * @param element
 */
const useEventListener = (eventName, handler, element = window) => {
  // Create a ref that stores handler
  const savedHandler = useRef()

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler
  }, [handler])

  useEffect(
    () => {
      // Make sure element supports addEventListener
      // On
      const isSupported = element && element.addEventListener
      if (!isSupported) return

      // Create event listener that calls handler function stored in ref
      const eventListener = (event) => {
        savedHandler.current(new PlatformEvent(event, { value: event.target.value }))
      }

      // Add event listener
      element.addEventListener(eventName, eventListener)

      // Remove event listener on cleanup
      // eslint-disable-next-line consistent-return
      return () => element.removeEventListener(eventName, eventListener)
    },
    [eventName, element], // Re-run if eventName or element changes
  )
}

export default useEventListener
